import { WebApiActionGet, WebApiActionPost, WebApiActionPut } from "components/ajax/WebApi";
import rootUrl from "./url";


const baseUrl = rootUrl + "api/payments";


export enum PaymentState {
    Created = 0,
    Sended = 1,
    Accepted = 2,
    Storno = 3,
}

export enum PaymentDisposition {
    None = 0,
    Required = 1,
    Optional = 2,
    Paid = 3,
}

export interface Payment {
    id: number;
    ownerId: number;
    year: number;
    state: PaymentState;
    sendDate?: Date,
    amount?: number;
    variableSymbol?: string;
    specificSymbol?: string;
    items: PaymentItem[];
}

export interface PaymentSpec {
    disposition?: PaymentDisposition;
    amount?: number;
    half?: boolean;
    profi?: boolean;
    officialClass?: number;
    price?: number;
    halfPrice?: number;
    profiPrice?: number;
    profiHalfPrice?: number;
    priceClass1?: number;
    priceClass2?: number;
    priceClass3?: number;
    selected?: boolean;
    selectedClass?: number;
}

export interface PaymentItem {
    memberId: number;
    extFeeDiscount?: number;
    sp?: PaymentSpec;
    zcp?: PaymentSpec;
    rcp?: PaymentSpec;
    por?: PaymentSpec;
    fun?: PaymentSpec;
    tre?: PaymentSpec;
}


export const apiGetPayments = function (ownerId: number): WebApiActionGet<Payment[]> {
    return new WebApiActionGet<Payment[]>(`${baseUrl}/${ownerId}`);
}

export const apiGetPayment = function (ownerId: number, paymentId: number): WebApiActionGet<Payment> {
    return new WebApiActionGet<Payment>(`${baseUrl}/${ownerId}/${paymentId}`);
}

export const apiGetPaymentAvailable = function (ownerId: number, year: number): WebApiActionGet<Payment> {
    return new WebApiActionGet<Payment>(`${baseUrl}/${ownerId}/available?year=${year}`);
}

export const apiPostPayment = function (ownerId: number): WebApiActionPost<Payment, Payment> {
    return new WebApiActionPost<Payment, Payment>(`${baseUrl}/${ownerId}`);
}

export const apiPutPayment = function (ownerId: number, paymentId: number): WebApiActionPut<Payment, Payment> {
    return new WebApiActionPut<Payment, Payment>(`${baseUrl}/${ownerId}/${paymentId}`);
}




export const apiGetQrCodesUrl = function (ownerId: number, paymentId: number) {
    return `${baseUrl}/${ownerId}/${paymentId}/qrcode`;
}